/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSphereDto } from '../../models/backend-sphere-dto';

export interface AccountSpheresList$Params {}

export function accountSpheresList(
  http: HttpClient,
  rootUrl: string,
  params?: AccountSpheresList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendSphereDto>>> {
  const rb = new RequestBuilder(rootUrl, accountSpheresList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendSphereDto>>;
    }),
  );
}

accountSpheresList.PATH = '/api/account/spheres/';
